import ShipperOrderCard from './component';
export default ShipperOrderCard;
